<template>
  <div>
    <!--Header Components-->
    <base-header class="pb-6" type="">
      <b-row class="align-items-center py-4">
        <b-col lg="6" cols="7">
          <!-- <h6 class="h2 text-white d-inline-block mb-0">{{$route.name}}</h6> -->
          <h6 class="h2 d-inline-block mb-0">{{ language_terms[$route.name] }} {{employee.name}}</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-breadcrumb />
          </nav>
        </b-col>
      </b-row>
    </base-header>
    <!--contents-->
    <b-container fluid class="mt--6 container-padding">
      <b-row>
        <div>
            <loading :active.sync="loading" 
                color= '#007bff'
                :width= '128'
                :height= '128'
                loader='dots'
                :can-cancel="true" 
                :is-full-page="true">
            </loading>
        </div>
        <b-col lg="12">
          <div class="card-wrapper">
            <b-card no-body>
              <b-tabs pills card>
                <!--Basic information Tab-->
                <b-tab title="Main" active>
                  <b-card-text>
                    <card>
                      <div slot="header">
                        <b-row>
                          <b-col lg="6">
                              <h3>{{language_terms['BASIC_INFORMATION']}} 
                                  <span v-if="employee.code">({{employee.code}})</span>
                              </h3>
                          </b-col>
                        </b-row>
                      </div>
                      <b-row>
                        <b-col md="2">
                          <base-input :label="language_terms['CODE']" v-model="employee.code" :disabled="disabled"></base-input>
                        </b-col>
                        <b-col md="8">
                          <base-input :label="language_terms['NAME']" v-model="employee.name" :disabled="disabled"></base-input>
                        </b-col>
                        <b-col md="2">
                          <base-input label="Date Joined" type = "date" v-model="employee.date_joined" :disabled="disabled"></base-input>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="3">
                          <base-input
                            :disabled="disabled"
                            :label="language_terms['NRIC']"
                            v-model="employee.uen"
                          ></base-input>
                        </b-col>                        
                        <b-col cols="3">
                          <base-input
                            :disabled="disabled"
                            :label="language_terms['MOBILE']"
                            v-model="employee.contact_mobile"
                          ></base-input>
                        </b-col>                        
                        <b-col cols="3">
                          <base-input
                            :disabled="disabled"
                            :label="language_terms['EMAIL']"
                            v-model="employee.contact_email"
                          ></base-input>
                        </b-col>
                        <b-col cols="3">
                          <base-input
                            :disabled="disabled"
                            :label="language_terms['TELEPHONE']"
                            v-model="employee.contact_telephone"
                          ></base-input>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col md="12">
                            <base-input :label="language_terms['REMARKS']">
                                <textarea
                                class="form-control"
                                id="exampleFormControlTextarea1"
                                rows="10"
                                v-model="employee.remarks"
                                :disabled="disabled">
                                </textarea>
                            </base-input>
                        </b-col>

                        <!-- <b-col cols="3" v-for = "(meta, i) in employee.metas" :key="i">
                            <label class="form-control-label" v-if="meta.key == 'whatsapp'">{{language_terms["WHATSAPP_MOBILE"]}}</label>
                            <label class="form-control-label" v-if="meta.key == 'facebook'">{{language_terms["FACEBOOK"]}}</label>
                            <base-input :disabled="disabled" v-model="meta.value"></base-input>
                        </b-col> -->
                      </b-row>                         
                    </card>
                    <card v-if="0">
                      <h3 slot="header">
                        {{ language_terms["CONTACT_INFO"] }}
                      </h3>
                      <b-row>
                        <b-col cols="4">
                          <base-input
                            :disabled="disabled"
                            :label="language_terms['MOBILE']"
                            v-model="employee.contact_mobile"
                          ></base-input>
                        </b-col>                        
                        <b-col cols="4">
                          <base-input
                            :disabled="disabled"
                            :label="language_terms['EMAIL']"
                            v-model="employee.contact_email"
                          ></base-input>
                        </b-col>
                        <b-col cols="4">
                          <base-input
                            :disabled="disabled"
                            :label="language_terms['TELEPHONE']"
                            v-model="employee.contact_telephone"
                          ></base-input>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col md="12">
                            <base-input :label="language_terms['REMARKS']">
                                <textarea
                                class="form-control"
                                id="exampleFormControlTextarea1"
                                rows="5"
                                v-model="employee.remarks"
                                :disabled="disabled">
                                </textarea>
                            </base-input>
                        </b-col>

                        <!-- <b-col cols="3" v-for = "(meta, i) in employee.metas" :key="i">
                            <label class="form-control-label" v-if="meta.key == 'whatsapp'">{{language_terms["WHATSAPP_MOBILE"]}}</label>
                            <label class="form-control-label" v-if="meta.key == 'facebook'">{{language_terms["FACEBOOK"]}}</label>
                            <base-input :disabled="disabled" v-model="meta.value"></base-input>
                        </b-col> -->
                      </b-row>                      
                    </card>
                    <b-card v-if="0">
                      <h3 slot="header">
                        {{ language_terms["OTHERS"] }}
                      </h3>
                    </b-card>
                  </b-card-text>
                  <div class="floating-bar">
                     <div class="floating-bar-container" align="center">
                       <b-button-group>
                          <b-button class="transparent-btn"  @click="editContact" v-if="disabled">
                             <i class="fas fa-edit mr-2 text-primary"></i>{{language_terms['EDIT']}}
                          </b-button>
                          <b-button class="transparent-btn"  @click="save" v-if="!disabled">
                             <i class="fas fa-save mr-2 text-info"></i>{{language_terms['SAVE']}}
                          </b-button>
                          <b-button class="transparent-btn"  @click="cancel" v-if="!disabled">
                             <i class="fa fa-times mr-2 text-warning"></i>{{language_terms['CANCEL']}}
                          </b-button>
                          <b-button class="transparent-btn" @click="deleteContact" v-if="$route.params.id != '_new'">
                             <i class="fas fa-trash mr-2 text-danger"></i>{{language_terms['DELETE']}}
                          </b-button>
                       </b-button-group>
                     </div>
                  </div>
                </b-tab>

                <b-tab title="Transactions" v-if="show_unit_tab">
                  <card>
                    <!-- Form for Adding/Updating Transaction -->
                    <b-form @submit.prevent="isEditingTransaction ? updateTransaction() : addTransaction()" class="mb-2">
                      <b-row>
                        <b-col md="3">
                          <b-form-group label="Balance" label-for="transaction-balance" >
                            <b-form-input
                              id="transaction-balance"
                              v-model="employee.summary.transactions.amount"
                              disabled
                            ></b-form-input>
                          </b-form-group>
                        </b-col>          
                        <b-col md="3">
                          <b-form-group label="Total Credit" label-for="transaction-balance" >
                            <b-form-input
                              id="transaction-balance"
                              v-model="employee.summary.transactions.total_credit"
                              disabled 
                            ></b-form-input>
                          </b-form-group>
                        </b-col>   
                        <b-col md="3">
                          <b-form-group label="Total Debit" label-for="transaction-balance" >
                            <b-form-input
                              id="transaction-balance"
                              v-model="employee.summary.transactions.total_debit"
                              disabled 
                            ></b-form-input>
                          </b-form-group>
                        </b-col>
                        <b-col md="3" @click = "onClickPayNow()">
                          <b-form-group label="PayNow" label-for="paynow" >
                            <b-form-input
                              id="paynow"
                              v-model="employee.paynow"
                              disabled 
                            ></b-form-input>
                          </b-form-group>
                        </b-col>
                      </b-row>    
                      <b-row class="align-items-center">
                        <b-col md="2">
                          <b-form-group label="Date" label-for="transaction-date">
                            <b-form-input
                              id="transaction-date"
                              v-model="transaction.date"
                              type="date"
                              required
                            ></b-form-input>
                          </b-form-group>
                        </b-col>
                        <b-col md="3">
                          <b-form-group label="Type" label-for="transaction-type">
                            <b-form-select
                              id="transaction-type"
                              v-model="transaction.type"
                              :options="transactionTypes"
                              required
                            ></b-form-select>
                          </b-form-group>
                        </b-col>
                        <b-col md="1">
                          <b-form-group label="Qty">
                            <b-form-input
                              v-model="transaction.qty"
                              type="text"
                              @blur="formatAmountInput('qty', transaction)"
                            ></b-form-input>
                          </b-form-group>
                        </b-col>
                        <b-col md="2">
                          <b-form-group label="Unit Amount">
                            <b-form-input
                              v-model="transaction.amount_unit"
                              type="text"
                              @blur="formatAmountInput('amount_unit', transaction)"
                            ></b-form-input>
                          </b-form-group>
                        </b-col>
                        <b-col md="2">
                          <b-form-group label="Amount">
                            <b-form-input disabled
                              v-model="transaction.amount"
                              type="text"
                              @blur="formatAmountInput('amount', transaction)"
                            ></b-form-input>
                          </b-form-group>
                        </b-col>
                        <b-col md="2">
                          <b-form-group label="Reference" label-for="transaction-reference1">
                            <b-form-input
                              id="transaction-reference1"
                              v-model="transaction.reference"
                            ></b-form-input>
                          </b-form-group>
                        </b-col>
                        <b-col md="3">
                          <b-form-group label="Project" label-for="transaction-project-code">
                            <b-form-input
                              id="transaction-project-code"
                              v-model="transaction.project_code"
                            ></b-form-input>
                          </b-form-group>
                        </b-col>
                        <b-col md="7">
                          <b-form-group label="Remarks" label-for="transaction-remarks">
                            <b-form-input
                              id="transaction-remarks"
                              v-model="transaction.remarks"
                            ></b-form-input>
                          </b-form-group>
                        </b-col>
                        <b-col md="2" class="d-flex align-items-center mt-1">
                          <!-- Conditional Buttons -->
                          <b-button type="submit" variant="success" class="mr-2">
                            {{ isEditingTransaction ? "Update" : "Add" }}
                          </b-button>
                          <b-button variant="danger" v-if="isEditingTransaction" @click="cancelEditTransaction">
                            Cancel
                          </b-button>
                          <b-button variant="danger" v-if="isEditingTransaction" @click="confirmDeleteTransaction"><i class="fas fa-trash mr-2"></i></b-button>
                        </b-col>
                      </b-row>
                    </b-form>

                    <b-table
                      striped
                      hover
                      :items="employee.transactions"
                      :fields="transactionFields"
                      responsive="sm"
                      class="mt-4"
                      @row-clicked="handleTransactionRowClick"
                    >
                    </b-table>

                    <!-- Delete Confirmation Modal -->
                    <b-modal
                      id="delete-transaction-confirmation-modal"
                      v-model="showDeleteTransactionModal"
                      title="Confirm Deletion"
                      ok-variant="danger"
                      ok-title="Delete"
                      cancel-title="Cancel"
                      @ok="deleteTransaction"
                    >
                      Are you sure you want to delete this transaction?
                    </b-modal>
                  </card>
                </b-tab>
                

                <b-tab title="Recurrings" v-if="show_unit_tab">
                  <card>
                    <!-- Form for Adding/Updating Recurring -->
                    <b-form @submit.prevent="isEditingRecurring ? updateRecurring() : addRecurring()" class="mb-2">
                      <b-row class="align-items-center">
                        <b-col md="2">
                          <b-form-group label="Start Date" label-for="date-start">
                            <b-form-input
                              id="date-start"
                              v-model="recurring.date_start"
                              type="date"
                              required
                            ></b-form-input>
                          </b-form-group>
                        </b-col>
                        <b-col md="2">
                          <b-form-group label="End Date" label-for="date-end">
                            <b-form-input
                              id="date-end"
                              v-model="recurring.date_end"
                              type="date"
                            ></b-form-input>
                          </b-form-group>
                        </b-col>
                        <b-col md="2">
                          <b-form-group label="Frequency" label-for="recurring-frequency">
                            <b-form-select
                              id="recurring-frequency"
                              v-model="recurring.frequency"
                              :options="recurringFrequencies"
                              required
                            ></b-form-select>
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group label="Type" label-for="recurring-type">
                            <b-form-select
                              id="recurring-type"
                              v-model="recurring.type"
                              :options="transactionTypes"
                              required
                            ></b-form-select>
                          </b-form-group>
                        </b-col>
                        <b-col md="2">
                          <b-form-group label="Amount">
                            <b-form-input
                              v-model="recurring.amount"
                              type="text"
                              @blur="formatAmountInput('amount', recurring)"
                            ></b-form-input>
                          </b-form-group>
                        </b-col>
                        <b-col md="4">
                          <b-form-group label="Project" label-for="recurring-project-code">
                            <b-form-input
                              id="recurring-project-code"
                              v-model="recurring.project_code"
                            ></b-form-input>
                          </b-form-group>
                        </b-col>
                        <b-col md="6">
                          <b-form-group label="Remarks" label-for="recurring-remarks">
                            <b-form-input
                              id="recurring-remarks"
                              v-model="recurring.remarks"
                            ></b-form-input>
                          </b-form-group>
                        </b-col>
                        <b-col md="2" class="d-flex align-items-center">
                          <!-- Conditional Buttons -->
                          <b-button type="submit" variant="success" class="mr-2">
                            {{ isEditingRecurring ? "Update" : "Add" }}
                          </b-button>
                          <b-button variant="danger" v-if="isEditingRecurring" @click="cancelEditRecurring">
                            Cancel
                          </b-button>
                          <b-button variant="danger" v-if="isEditingRecurring" @click="confirmDeleteRecurring(recurring)"><i class="fas fa-trash"></i></b-button>                          
                        </b-col>
                      </b-row>
                    </b-form>

                    <b-table
                      striped
                      hover
                      :items="employee.recurrings"
                      :fields="recurringFields"
                      responsive="sm"
                      class="mt-4"
                      @row-clicked="handleRecurringRowClick"
                    >
                    </b-table>

                    <!-- Delete Confirmation Modal -->
                    <b-modal
                      id="delete-confirmation-modal"
                      v-model="showDeleteRecurringModal"
                      title="Confirm Deletion"
                      ok-variant="danger"
                      ok-title="Delete"
                      cancel-title="Cancel"
                      @ok="deleteRecurring"
                    >
                      Are you sure you want to delete this recurring item?
                    </b-modal>
                  </card>
                </b-tab>

          
                
                <b-tab title="Configuration" v-if="show_unit_tab">
                  <card>
                    <!-- Add Meta Key/Value Inputs and Add Button -->
                    <b-row>
                      <b-col md="3">
                        <b-form-group label="Key" md="3">
                          <b-form-select v-model="meta.key" :options="metaKeyOptions" />
                        </b-form-group>                      
                      </b-col>
                      <b-col md="8">
                        <base-input label="Value" v-model="meta.value"/>
                      </b-col>

                      <b-col md="1" class="mt-2">
                        <base-button type="success" @click="onClickAddMeta" class="float-left mt-4" size="md">
                          <i class="fa fa-plus"/>
                        </base-button>                    
                      </b-col>
                    </b-row>

                    <!-- Meta Values Table with Delete Buttons -->
                    <b-table striped hover :items="employee.metas" :fields="metaFields" responsive="sm" v-if="employee.metas.length > 0">
                    <!-- Key, Value, and Time Created Columns -->
                    <template #cell(timeCreated)="data">
                      {{ formatDate(data.item.timeCreated) }}
                    </template>

                    <!-- Delete Button Column -->
                    <template #cell(actions)="data">
                      <b-button variant="danger" size="sm" @click="deleteMeta(data.item.id, data.index)">
                        Delete
                      </b-button>
                    </template>
                  </b-table>
                  </card>
                </b-tab>
              
              </b-tabs>
            </b-card>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
import Vue from 'vue';
import flatPicker from "vue-flatpickr-component";
import moment from "moment";
import axios from "axios";
import { apiBaseUrl } from '../../apiRoutes';
import { apiRoutes } from '../../apiRoutes';
import { authHeader } from '../../global';

import priceSetup from '../Components/priceSetup.vue';

import Collapse from "@/components/Collapse/Collapse";
import CollapseItem from "@/components/Collapse/CollapseItem";
import { mapState } from "vuex";
import { Select, Option } from "element-ui";
import bankAccounts from "../Components/bankAccounts.vue";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  data() {
    return {
      isEditingTransaction: false, // Track editing state for transactions
      showDeleteTransactionModal: false,      
      showDeleteRecurringModal: false,
      recurringToDelete: null,
      isEditingRecurring: false, // Updated variable name
      currentRecurringIndex: null, // To track which recurring is being edited

      recurringFrequencies : [
        { value: null, text: 'Select' }, // Placeholder
        { value: 'DAILY', text: 'DAILY' },
        { value: 'WEEKLY', text: 'WEEKLY' },
        { value: 'MONTHLY', text: 'MONTHLY' },
        { value: 'YEARLY', text: 'YEARLY' },
      ],
      recurringFields: [
        { key: 'date_start', label: 'Start Date' },
        { key: 'date_end', label: 'End Date' },
        { key: 'frequency', label: 'Frequency' },
        { key: 'type', label: 'Type' },
        { key: 'amount', label: 'Amount' },
        { key: 'project_code', label: 'Project' },
        { key: 'remarks', label: 'Remarks' },
      ],      
      transactionFields: [
        { key: 'date', label: 'Date' },
        { key: 'type', label: 'Type' },
        { key: 'qty', label: 'Qty' },
        { key: 'amount_unit', label: 'Unit Amount' },
        { key: 'amount', label: 'Amount' },
        { key: 'amount_rolling', label: 'Balance' },
        { key: 'reference', label: 'Reference' },
        { key: 'project_code', label: 'Project' },
        { key: 'remarks', label: 'Remarks' },
      ],      
      transactionTypes: [
        { value: null, text: 'Select Type' }, // Placeholder
        { value: 'CREDIT - SALARY', text: 'CREDIT - SALARY' },
        { value: 'CREDIT - JOB', text: 'CREDIT - JOB' },
        { value: 'CREDIT - PENALTY REVERSAL', text: 'CREDIT - PENALTY REVERSAL' },
        { value: 'DEDUCT - PAYOUT', text: 'DEDUCT - PAYOUT' },
        { value: 'DEDUCT - VEHICLE RENTAL', text: 'DEDUCT - VEHICLE RENTAL' },
        { value: 'DEDUCT - VEHICLE DIESEL', text: 'DEDUCT - VEHICLE DIESEL' },
        { value: 'DEDUCT - PENALTY', text: 'DEDUCT - PENALTY' },
        { value: 'DEDUCT - FINE', text: 'DEDUCT - FINE' },
        // Add more types as needed
      ],
      recurring: {
        date_start: null,
        date_end: null,
        frequency: null,
        type: null,
        amount: null,
        remarks: null,
        project_code: null,        
      },
      transaction: {
        date: null,
        type: null,
        qty: "1",
        amount_unit: 0,
        amount: 0,
        reference: null,
        reference2: null,
        reference3: null,
        project_code: null,
        remarks: null,
      },
      metaKeyOptions: [
        { value: 'PACKAGE', text: 'PACKAGE' },
        { value: 'CAINIAO USER', text: 'CAINIAO USER' },
        { value: 'PAYNOW', text: 'PAYNOW' },
        
      ],  
      meta:{
        key:null,
        value:null,
      },
      is_edit:false,
      disabled:true,
      loading:false,
      addUnitModal: false,
      show_unit_tab: false,
      headerBgVariant: "primary",
      headerTextVariant: "light",
      bank_accounts:[],
      employee: {
        uen:null,
        contact_categories:[],
        name: "",
        country_code: "",
        currency_code: "",
        customer_credit_limit: "",
        customer_credit_term: "",
        address_street: "",
        address_district: "",
        address_city: "",
        address_district: "",
        address_postcode: "",
        address_country_code: "",
        contact_person: "",
        contact_mobile: "",
        contact_telephone: "",
        contact_telephone: "",
        contact_fax: "",
        contact_email: "",
        remarks: "",
        transactions:[],
        recurrings:[],
        summary:{
          transactions:
          {total_credit:0, total_debit:0, amount:0},
        },
        date_joined:null
      },
      options: ["list", "of", "options"],
    };
  },
  components: {
    flatPicker,
    Loading,
    Collapse,
    CollapseItem,
    [Select.name]: Select,
    [Option.name]: Option,
    priceSetup
  },
  computed: {
    metaFields() {
      return [
        { key: 'key', label: 'Key' },
        { key: 'value', label: 'Value' },
        { key: 'time_created', label: 'Time Created' },
        { key: 'actions', label: 'Actions' },
      ];
    },
    ...mapState({
      salesperson_list:state => state.employees.salesperson_list,
      filter: (state) => state.customers.filter,
      currencies: (state) => state.currencies.currencies,
      taxes: (state) => state.taxes.taxes,
      countries: (state) => state.countries.countries,
      employee_data: (state) => state.employees.data,
      language_terms: (state) => state.languages.language_terms,
      selected_lang: (state) => state.languages.selected_langauge,
      employee_is_created: (state) => state.employees.is_created,
      employee_is_updated: (state) => state.employees.is_updated,
      is_deleted: (state) => state.employees.is_deleted,
      metas_config: (state) => state.employees.metas_config,
      contact_categories: (state) => state.contactCategories.active_list,
      debtor_accounts: (state) => state.employees.debtor_accounts

    }),
  },
  watch:{
      customer_data:
        {
            deep:true,
            handler(){
                this.employee = this.employee_data
            }
        }
    
  },
  async mounted() 
  {
     this.loading= true
      if (this.$route.params.id == "_new") 
      {
        this.show_unit_tab = false;
        this.disabled = false
        await this.$store.dispatch("employees/fetchMetaConfig", {})
        this.employee.metas = this.metas_config
      } 
      else 
      {
        await this.retrieveEmployee(this.$route.params.id);
        this.show_unit_tab = true;
        this.disabled = true

        this.formatAmountInput('total_debit', this.employee.summary.transactions);
        this.formatAmountInput('total_credit', this.employee.summary.transactions);
        this.formatAmountInput('amount', this.employee.summary.transactions);

      }
      this.transaction.date = moment().format("YYYY-MM-DD")
      // this.transaction.type = 'DEDUCT - PAYOUT'
      this.loading = false
  },
  methods: {
    async onClickPayNow()
    {
      this.isEditingTransaction
      this.transaction.type = 'DEDUCT - PAYOUT'
      this.transaction.qty = "1"
      this.transaction.amount_unit = this.employee.summary.transactions.amount
      this.transaction.amount = this.employee.summary.transactions.amount

      await navigator.clipboard.writeText(this.employee.paynow)
    },
    // Handle row click for transactions
    handleTransactionRowClick(item) {
      this.isEditingTransaction = true;
      this.transaction = { ...item }; // Load the clicked transaction for editing
      this.transaction.amount = this.transaction.qty * this.transaction.amount_unit;
      this.formatAmountInput('amount', this.transaction);
    },

    // Handle row click for recurrings
    handleRecurringRowClick(item) {
      this.isEditingRecurring = true;
      this.currentRecurringIndex = this.employee.recurrings.indexOf(item);
      this.recurring = { ...item }; // Load the clicked recurring for editing
    },
    confirmDeleteRecurring(item) { // Renamed here
      // this.recurringToDelete = this.recurring; // Store the item to delete
      this.showDeleteRecurringModal = true; // Show modal
    },

    // Method to delete recurring
    async deleteRecurring() {
      if (!this.recurring) return;

      const payload = { id: this.recurring.id }; // Assume ID is the identifier
      try {
        const response = await axios.post(
          apiBaseUrl + "employees/delete-recurring",
          payload,
          authHeader()
        );

        if (response.data.code === 1) {
          await this.retrieveEmployee(this.$route.params.id);
          Vue.notify({ type: "success", text: "Recurring deleted successfully!" });
        }
      } catch (error) {
        Vue.notify({ type: "error", text: "Failed to delete recurring!" });
      } finally {
        this.showDeleteRecurringModal = false; // Hide modal
        this.isEditingRecurring = false
      }
    },

    formatAmountInput(key, parent = null) {
      var rawValue = 0
      if (parent === null)
        rawValue = this[key].toString().replace(/,/g, ''); // Remove commas
      else
        rawValue = parent[key].toString().replace(/,/g, ''); // Remove commas

      const numberValue = parseFloat(rawValue) || 0; // Convert to number, default to 0

      // Update the transaction with the formatted number for display
      if (parent === null)
        this[key] = numberValue.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      else
        parent[key] = numberValue.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      
      if (key == 'amount_unit' || key == 'qty')
      {
        let transaction_amount = Number(this.transaction.qty.toString().replace(/,/g, '')) * Number(this.transaction.amount_unit.toString().replace(/,/g, ''))
        this.transaction.amount = transaction_amount; //this.transaction.qty * this.transaction.amount_unit
        this.formatAmountInput('amount', parent)
      }
    },
    cancelEditTransaction() {
      let date = this.transaction.date

      this.isEditingTransaction = false;
      this.transaction = {
        date: date,
        type: null,
        qty: "1",
        amount_unit: null,
        amount: null,
        reference: null,
        project_code: null,
        remarks: null,
      };
    },    
    editRecurring(item) {
      this.isEditingRecurring = true; // Updated variable name
      this.currentRecurringIndex = this.employee.recurrings.indexOf(item);
      this.recurring = { ...item };
    },    
    async updateRecurring() {
      const updatedRecurring = { ...this.recurring };
      const payload = {
        ...updatedRecurring,
        id: this.employee.recurrings[this.currentRecurringIndex].id,
      };

      try {
        const response = await axios.post(
          apiBaseUrl + "employees/update-recurring",
          payload,
          authHeader()
        );

        if (response.data.code === 1) {
          this.$set(this.employee.recurrings, this.currentRecurringIndex, updatedRecurring);
          Vue.notify({ type: "success", text: "Recurring updated successfully!" });
          this.cancelEditRecurring();
          await this.retrieveEmployee(this.$route.params.id);
        }
      } catch (error) {
        Vue.notify({ type: "error", text: "Failed to update recurring!" });
      }
    },

    // Method to cancel editing
    cancelEditRecurring() {
      this.isEditingRecurring = false; // Updated variable name
      this.currentRecurringIndex = null;
      this.recurring = { date_start: null, date_end: null, frequency: null, type: null, amount: null, remarks: null, project_code: null };
    },    
    async addRecurring() {
      if (this.recurring.type) {
        this.recurring.contact_id = this.employee.id
        let payload = this.recurring
        payload.amount = parseFloat(this.recurring.amount.replace(/,/g, ''))
        axios.post(apiBaseUrl + "employees/add-recurring", payload, authHeader()).then((response) => {
            if (response.data.code == 1) 
            {
              this.recurring.amount = null;
              this.recurring.remarks = null;
              this.retrieveEmployee(this.$route.params.id);
            } 
        })
        .catch((error) => 
        {
            if (error.response) 
            {
                Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
            } 
        });
      }
    },

    confirmDeleteTransaction(item) {
      this.transactionToDelete = this.transaction;
      this.showDeleteTransactionModal = true;
    },

    // Delete transaction
    async deleteTransaction() {
      if (!this.transactionToDelete) return;

      const payload = { id: this.transactionToDelete.id }; // Use ID to identify transaction
      try {
        const response = await axios.post(
          `${apiBaseUrl}employees/delete-transaction`,
          payload,
          authHeader()
        );

        if (response.data.code === 1) {
          this.fetchTransactions();
          Vue.notify({ type: "success", text: "Transaction deleted successfully!" });
        }
      } catch (error) {
        Vue.notify({ type: "error", text: "Failed to delete transaction!" });
      } finally {
        this.showDeleteTransactionModal = false;
        this.transactionToDelete = null;
        this.isEditingTransaction = false;
      }
    },

    async updateTransaction() {
      const payload = { ...this.transaction };

      try {
        const response = await axios.post(
          apiBaseUrl + "employees/update-transaction",
          payload,
          authHeader()
        );

        if (response.data.code === 1) {
          this.fetchTransactions();
          Vue.notify({ type: "success", text: "Transaction updated successfully!" });
          this.cancelEditTransaction();
        }
      } catch (error) {
        Vue.notify({ type: "error", text: "Failed to update transaction!" });
      }
    },
    editTransaction(item) {
      this.isEditingTransaction = true;
      this.transaction = { ...item };
      this.transaction.amount = (this.transaction.qty * this.transaction.amount_unit)
      this.formatAmountInput('amount', this.transaction)

    },    
    async addTransaction() {
      if (this.transaction.type) {
        this.transaction.contact_id = this.employee.id
        let payload = this.transaction
        payload.qty = parseFloat(this.transaction.qty.replace(/,/g, ''))
        payload.amount_unit = parseFloat(this.transaction.amount_unit.replace(/,/g, ''))
        payload.amount = parseFloat(this.transaction.amount.replace(/,/g, ''))
        axios.post(apiBaseUrl + "employees/add-transaction", payload, authHeader()).then((response) => {
            if (response.data.code == 1) 
            {
              this.transaction.qty = "1";
              this.transaction.amount_unit = null;
              this.transaction.amount = null;
              this.transaction.reference = null;
              this.transaction.remarks = null;
              this.transaction.project_code = null;
              this.fetchTransactions();
            } 
        })
        .catch((error) => 
        {
            if (error.response) 
            {
                Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
            } 
        });
      }
    },
    async onClickAddMeta() {
      if (this.meta.key && this.meta.value) {
        this.meta.contact_id = this.employee.id
        let payload = this.meta
        axios.post(apiRoutes["EMPLOYEE_ADD_META"], payload, authHeader()).then((response) => {
            if (response.data.code == 1) 
            {
              this.meta.key = null;
              this.meta.value = null;
              this.fetchMetas();
            } 
        })
        .catch((error) => 
        {
            if (error.response) 
            {
                Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
            } 
        });
      }
    },
    async fetchRecurrings()
    {
      this.transaction.contact_id = this.employee.id
      let payload = this.transaction
      axios.post(apiBaseUrl + "employees/retrieve-recurrings", payload, authHeader()).then((response) => {
          if (response.data.code == 1) 
          {
            this.employee.recurrings = response.data.data.details
          } 
      })
      .catch((error) => 
      {
          if (error.response) 
          {
              Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
          } 
      });
    },
    async fetchTransactions()
    {
      this.transaction.contact_id = this.employee.id
      let payload = this.transaction
      axios.post(apiBaseUrl + "employees/retrieve-transactions", payload, authHeader()).then((response) => {
          if (response.data.code == 1) 
          {
            this.employee.summary.transactions = response.data.data.summary
            this.employee.transactions = response.data.data.details

            this.formatAmountInput('total_debit', this.employee.summary.transactions);
            this.formatAmountInput('total_credit', this.employee.summary.transactions);
            this.formatAmountInput('amount', this.employee.summary.transactions);
          } 
      })
      .catch((error) => 
      {
          if (error.response) 
          {
              Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
          } 
      });
    },
    async fetchMetas() {
      this.meta.contact_id = this.employee.id
      let payload = this.meta
      axios.post(apiRoutes["EMPLOYEE_RETRIEVE_METAS"], payload, authHeader()).then((response) => {
          if (response.data.code == 1) 
          {
            this.employee.metas = response.data.data
          } 
      })
      .catch((error) => 
      {
          if (error.response) 
          {
              Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
          } 
      });
    },
    // Method to delete a meta by index
    async deleteMeta(id, index) {
      let payload = {id:id}
      axios.post(apiRoutes["EMPLOYEE_DELETE_META"], payload, authHeader()).then((response) => {
          if (response.data.code == 1) 
          {
            this.employee.metas.splice(index, 1);
            Vue.notify({
              group: "notify",
              type: "success",
              text: 'Meta deleted successfully!',
            });
          } 
      })
      .catch((error) => 
      {
        if (error.response) 
        {
            Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
        } 
      });
    },  
    handleCollaspe(index, row)
    {
        if(row.is_collapsed)
        {
           row.is_collapsed = false
        }
        else
        {
          row.is_collapsed = true
        }
        this.$set(this.employee.units, index , row) 
    },
    editContact()
    {
      this.disabled =false
      this.is_edit= true
    },
    async deleteContact()
    {
        let response = await this.$confirm(this.language_terms['ARE_YOU_SURE_DELETE'] + '?', this.language_terms['CONFIRMATION'], {
                  confirmButtonText: this.language_terms['YES'],
                  cancelButtonText: this.language_terms['CANCEL'],
                  type: 'warning'
                }).catch(() => {
              this.$message.info(this.language_terms['ACTION_CANCEL'])
             })
        if (response === 'confirm') 
        {
            this.loading =true
            await this.$store.dispatch("employees/delete", this.employee);

            if(this.is_deleted)
            {
                await this.search();
                this.$router.push("/employees");
            }
           
            this.loading =false
        }
    },
    async retrieveEmployee(code) {
      this.loading =true
      await this.$store.dispatch("employees/fetch", {
        code: code,
      });

      this.employee = this.employee_data;
      this.loading = false
    },
    addDepartment() {
      this.loading = true

      this.loading = false
    },
    async search()
    {
        this.loading = true
        let filter = {keyword:"",active_only:"1"}
        if(this.filter)
        {
            filter = this.filter
        }
        await this.$store.dispatch('employees/quickSearch', filter)

        this.loading = false
    },
    async save() {
      this.loading = true
      if (this.$route.params.id == "_new") 
      {
        await this.$store.dispatch("employees/create", this.employee);

        if(this.employee_is_created)
        {
          // refresh the store
          await this.search();
          this.$router.push("/employees");
        }
      } 
      else 
      {
        await this.$store.dispatch("employees/update", this.employee);
        if(this.employee_is_updated)
        {
          location.reload();
        }
      }
      this.loading = false
    },
    cancel() {
      if(this.$route.params.id == '_new')
        this.$router.push("/employees");
      else
        location.reload();
    },
  },
};
</script>
